import React from 'react';
import styled from 'styled-components';

const StyledTooltip = styled.div`
  position: relative;
  top: 0;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  font-size: 14px;
  background: #888888ad;
  color: var(--black);
  font-weight: bold;
  cursor: pointer;
  &::after {
    content: attr(data-tooltip);
    position: absolute;
    top: -100%;
    left: 25px;
    background: var(--black);
    color: var(--white);
    padding: 5px 10px;
    display: none;
    border-radius: 8px;
    font-size: 0.8rem;
    min-width: 150px;
  }
  &:hover {
    &::after {
      display: block;
    }
  }
  @media (max-width: 576px) {
    &::after {
      right: 25px;
      left: auto;
    }
  }
`;

function Tooltip({ title, children, ...rest }) {
  return (
    <StyledTooltip data-tooltip={title} {...rest}>
      {children}
    </StyledTooltip>
  );
}

export default Tooltip;
